<table
  mat-table
  [dataSource]="result"
  multiTemplateDataRows
  class="mat-elevation-z8"
>
  <ng-container matColumnDef="portfolioDocument">
    <th mat-header-cell class="header" *matHeaderCellDef>CNPJ Origem</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioDocument }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioName">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Nome do Fundo Origem
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioBank">
    <th mat-header-cell class="header" *matHeaderCellDef>Banco Origem</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioBank }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioBranch">
    <th mat-header-cell class="header" *matHeaderCellDef>Agência Origem</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioBranch }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Conta Corrente Origem
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="operationTypeId">
    <th mat-header-cell class="header" *matHeaderCellDef>Tipo de Operação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.operationTypeId }}
    </td>
  </ng-container>

  <ng-container matColumnDef="operationValue">
    <th mat-header-cell class="header" *matHeaderCellDef>Valor da Operação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.operationValue | currency: "R$":"symbol":"1.2-2" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="receiverDocument">
    <th mat-header-cell class="header" *matHeaderCellDef>CNPJ Destino</th>
    <td mat-cell *matCellDef="let element">
      {{ element.receiverDocument }}
    </td>
  </ng-container>

  <ng-container matColumnDef="receiverName">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Nome do Fundo Destino
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.receiverName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="receiverBank">
    <th mat-header-cell class="header" *matHeaderCellDef>Banco Destino</th>
    <td mat-cell *matCellDef="let element">
      {{ element.receiverBank }}
    </td>
  </ng-container>

  <ng-container matColumnDef="receiverBranch">
    <th mat-header-cell class="header" *matHeaderCellDef>Agência Destino</th>
    <td mat-cell *matCellDef="let element">
      {{ element.receiverBranch }}
    </td>
  </ng-container>

  <ng-container matColumnDef="receiverAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>Conta Destino</th>
    <td mat-cell *matCellDef="let element">
      {{ element.receiverAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="annotations">
    <th mat-header-cell class="header" *matHeaderCellDef>Observação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.annotations }}
    </td>
  </ng-container>

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td
      mat-cell
      *matCellDef="let element"
      [attr.colspan]="ColumnsTransfer.length"
    >
      <div
        class="example-element-detail"
        [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
      >
        <div class="example-element-description">
          <div class="title-description">
            <h5>Erros encontrados:</h5>
          </div>
          <ul *ngFor="let error of element.errors">
            <li>
              {{ error }}
            </li>
          </ul>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="ColumnsTransfer"></tr>
  <tr
    mat-row
    *matRowDef="let element; columns: ColumnsTransfer"
    class="example-element-row"
    [class.example-expanded-row]="expandedElement === element"
    (click)="expandedElement = expandedElement === element ? null : element"
  ></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: ['expandedDetail']"
    class="example-detail-row"
  ></tr>
</table>
